import "./App.css";
import NavBar from "./components/NavBar";
// import Footer from "./components/Footer";
import React, { useState } from 'react';
import { BrowserRouter as Router,  Route, Routes } from "react-router-dom";
// import { Home } from "./components/Pages/Home";
import { About } from "./components/Pages/About";
import { Contact } from "./components/Pages/Contact";
import { State } from "./components/Pages/State";
import SiteEventSelector from "./components/SiteEventSelector";
import DateEventSelector from "./components/DateEventSelector";
import DayEventSelector from "./components/DayEventSelector";

function App() {

const [sidebar, setSidebar] = useState(true);

  const toggleSidebar = () => {
    setSidebar(!sidebar);
  };

  return (
      <div className={`app-container ${sidebar ? 'sidebar-visible' : 'sidebar-hidden'}`}>
            <Router>
                <NavBar sidebar={sidebar} toggleSidebar={toggleSidebar} />
                <div className="body-image">
                    <div className="body-image-2">
                        <div className="pages-container">
                            <Routes>
                                {/* <Route path="/" element={<Home />} /> */}
                                <Route path="/" element={<State />} />
                                <Route path="/about" element={<About />} />
                                <Route path="/contact" element={<Contact />} />
                                <Route path="/state" element={<State/>} />
                                <Route path="/sites/:stateId/:selectedStateName" element={<SiteEventSelector />} />
                                {/* <Route path="/events/:stateId/:selectedSite/:selectedSiteName" element={<DateEventSelector />} /> */}
                                <Route path="/month_events/:stateId/:selectedSite/:selectedSiteName" element={<DateEventSelector />} />
                                <Route path="/day_events/:stateId/:selectedSite/:selectedSiteName" element={<DayEventSelector />} />
                            </Routes>
                        </div>
                    </div>
                </div>
                {/* <Footer /> */}
            </Router>
      </div>
  );
}

export default App;